import { render, staticRenderFns } from "./lossWeightClinicalExercise.vue?vue&type=template&id=069d1290&scoped=true&"
import script from "./lossWeightClinicalExercise.vue?vue&type=script&lang=js&"
export * from "./lossWeightClinicalExercise.vue?vue&type=script&lang=js&"
import style0 from "./lossWeightClinicalExercise.vue?vue&type=style&index=0&id=069d1290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069d1290",
  null
  
)

export default component.exports